function handleAssetMap() {
  const map = new Map();
  map.set("square-1", "0026dc28-906b-4ff7-9577-c26abf5b5012"); // 3 prints
  map.set("square-2", "89d18ffe-2bc9-41cc-a730-5db518d04bd6"); // 3 prints alternative
  map.set("square-3", "23418be9-6028-486e-9482-54b4e9768e87"); // 4 prints
  map.set("square-4", "1a881a8c-aa32-4faf-a5ae-0e9a6187ca12"); // 5 prints
  map.set("square-5", "75db2a4f-cb21-4ca8-9ba9-fe262a2c69ce"); // 6 prints 32387977609303
  map.set("square-6", "ca94dda9-b60c-49e2-9156-eadb24c6897a"); // 9 prints 32387977740375
  map.set("square-7", "d9d1fa72-4ead-4ac6-b9c7-1033bc6b651f"); //13 prints 32387977936983
  map.set("square-8", "f7f23c05-6619-475a-b7bf-b7af11243e21"); // 16 prints 32387978068055
  map.set("shunkawauken", "b565ec2e-edcf-4e99-9f46-a0ff18f51776");
  map.set("wall-display-shunkawauken", "b565ec2e-edcf-4e99-9f46-a0ff18f51776");
  map.set("linville", "fba16900-7b86-410f-a48d-111b23592e9e");
  map.set("wall-display-linville", "fba16900-7b86-410f-a48d-111b23592e9e");
  map.set("sunburst", "3f90f102-6c2b-48af-a34f-0f6575c4057c");
  map.set("wall-display-sunburst", "3f90f102-6c2b-48af-a34f-0f6575c4057c");
  map.set("mingo", "c1432278-c532-4633-a1ec-a042d20d71d5");
  map.set("wall-display-mingo", "c1432278-c532-4633-a1ec-a042d20d71d5");
  map.set("crabtree", "d5f10893-b22c-4502-ae5a-6ddb32006122");
  map.set("wall-display-crabtree", "d5f10893-b22c-4502-ae5a-6ddb32006122");
  map.set("glassmine", "aa63869e-e278-4790-a93b-58d33c017486");
  map.set("wall-display-glassmine", "aa63869e-e278-4790-a93b-58d33c017486");
  map.set("cullasaja", "a58f8ef4-bf0d-44e1-816c-3dcbfe594bbe");
  map.set("wall-display-cullasaja", "a58f8ef4-bf0d-44e1-816c-3dcbfe594bbe");
  map.set("hickory", "517abdb1-41af-437b-be89-9f630880c429");
  map.set("wall-display-hickory", "517abdb1-41af-437b-be89-9f630880c429");
  map.set("setrock", "9ed3c5c9-e973-4a3f-af96-f6e0094c1a87");
  map.set("wall-display-setrock", "9ed3c5c9-e973-4a3f-af96-f6e0094c1a87");
  map.set("silver", "e5bc80f9-762e-46a2-b21d-1521c897d4a5");
  map.set("wall-display-silver", "e5bc80f9-762e-46a2-b21d-1521c897d4a5");
  map.set("rainbow", "205ee8eb-8881-4d46-82f7-2d65c99200ea");
  map.set("wall-display-rainbow", "205ee8eb-8881-4d46-82f7-2d65c99200ea");
  map.set("stairway", "62a9089a-5bd8-4f97-ae3d-a292858ef1b4");
  map.set("wall-display-stairway", "62a9089a-5bd8-4f97-ae3d-a292858ef1b4");
  map.set("wildcat", "ba3bd1b9-4e39-4739-84b5-eb8f09e197be");
  map.set("wall-display-wildcat", "ba3bd1b9-4e39-4739-84b5-eb8f09e197be");
  map.set("catawba", "0f6db45c-fe2b-480a-a158-b71489e55aaa");
  map.set("wall-display-catawba", "0f6db45c-fe2b-480a-a158-b71489e55aaa");
  map.set("hickory-nut", "517abdb1-41af-437b-be89-9f630880c429");
  map.set("wall-display-hickory-nut", "517abdb1-41af-437b-be89-9f630880c429");
  map.set("silver-run", "e7a2ed06-5d0a-4a86-96ae-0cfc2d45c3df");
  map.set("wall-display-silver-run", "e7a2ed06-5d0a-4a86-96ae-0cfc2d45c3df");

  return map;
}

function skuAssetMap() {
  const map = new Map();
  // need to update this to have parent configurator assets and child product assets
  map.set("collage-prints", "1c857fd8-ed7e-4f7b-994d-2f6fcf69da50");
  map.set("wall-display-prints", "cd8d180a-75aa-4cbb-9981-88ee8e445328");

  //Collage models
  map.set("CP-COL-COL1-0000-001", "0026dc28-906b-4ff7-9577-c26abf5b5012"); // 3 prints 32379468283991
  map.set("CP-COL-COL5-0000-001", "89d18ffe-2bc9-41cc-a730-5db518d04bd6"); // 3 prints alternative 32387976626263
  map.set("CP-COL-COL10-0000-001", "23418be9-6028-486e-9482-54b4e9768e87"); // 4 prints 32387976822871
  map.set("CP-COL-COL14-0000-001", "1a881a8c-aa32-4faf-a5ae-0e9a6187ca12"); // 5 prints 32387976953943
  map.set("CP-COL-COL19-0000-001", "75db2a4f-cb21-4ca8-9ba9-fe262a2c69ce"); // 6 prints 32387977609303
  map.set("CP-COL-COL23-0000-001", "ca94dda9-b60c-49e2-9156-eadb24c6897a"); // 9 prints 32387977740375
  map.set("CP-COL-COL27-0000-001", "d9d1fa72-4ead-4ac6-b9c7-1033bc6b651f"); 
  map.set("CP-COL-COL28-0000-001", "d9d1fa72-4ead-4ac6-b9c7-1033bc6b651f"); //13 prints 32387977936983
  map.set("CP-COL-COL32-0000-001", "f7f23c05-6619-475a-b7bf-b7af11243e21"); // 16 prints 32387978068055

  // Triptychs
  map.set("CP-TRIP-CLFL-0000-001", "bd7167ba-af06-4ea3-82ed-8577f50f13a7"); //Classic Flow Triptych 41012112031925
  map.set("CP-TRIP-CLAS-0000-001", "f1633cfa-f462-49f1-9793-b484a5f80f3a"); //Classic Triptych 41012112556213
  map.set("CP-TRIP-CZFL-0000-001", "727fc1b0-75cf-43e2-9089-535eb9aae8de"); //Cozy Flow Triptych 41012111835317
  map.set("CP-TRIP-COZ-0000-001", "93faf5a0-098b-4409-95dd-072dbe2ca3ca"); //Cozy Triptych 41012113113269

  //collageSize
  map.set("12", "170d0959-eee1-4b95-a75a-ce71ee678415");
  map.set("18", "14126c12-9e2c-4cb3-9761-13af08fa27a0");
  map.set("24", "30dacebf-c090-49e1-bccd-ee1ca3d105ec");
  map.set("30", "5629515c-cae0-49ca-9ec0-c581c63d3fe9");

  //depth size options
  map.set("1", "952577cd-b9b3-4986-9704-6a21b576feca");
  map.set("2", "b9b5fa33-d723-4606-a31e-44680a5ca372");

  // walldisplay models
  map.set("CP-WALL-SHU-0000-001", "b565ec2e-edcf-4e99-9f46-a0ff18f51776"); //shunkawauken 32358157451351
  map.set("CP-WALL-LIN-0000-001", "fba16900-7b86-410f-a48d-111b23592e9e"); //linville 32357570314327
  map.set("CP-WALL-SUN-0000-001", "3f90f102-6c2b-48af-a34f-0f6575c4057c"); //sunbrust 32357576671319

  map.set("CP-WALL-MIN-0000-001", "c1432278-c532-4633-a1ec-a042d20d71d5"); //mingo 32358153814103
  map.set("CP-WALL-CRA-0000-001", "d5f10893-b22c-4502-ae5a-6ddb32006122"); //crabtree 32358156206167

  map.set("CP-WALL-GLA-0000-001", "aa63869e-e278-4790-a93b-58d33c017486"); //Glassmine 32357575655511
  map.set("CP-WALL-CUL-0000-001", "a58f8ef4-bf0d-44e1-816c-3dcbfe594bbe"); //Cullasaja 32357571723351
  map.set("CP-WALL-HIC-0000-001", "517abdb1-41af-437b-be89-9f630880c429"); //hickory 32357548130391
  map.set("CP-WALL-SET-0000-001", "9ed3c5c9-e973-4a3f-af96-f6e0094c1a87"); //setrock 32357577785431

  map.set("CP-WALL-SIL-0000-001", "e5bc80f9-762e-46a2-b21d-1521c897d4a5"); //silver 32358148046935
  map.set("CP-WALL-RAI-0000-001", "205ee8eb-8881-4d46-82f7-2d65c99200ea"); //rainbow 32361519939671
  map.set("CP-WALL-STA-0000-001", "62a9089a-5bd8-4f97-ae3d-a292858ef1b4"); //stairway 32358152568919

  map.set("CP-WALL-WIL-0000-001", "ba3bd1b9-4e39-4739-84b5-eb8f09e197be"); //wildcat 32361518301271
  map.set("CP-WALL-CAT-0000-001", "0f6db45c-fe2b-480a-a158-b71489e55aaa"); //catabwa 32361520463959

  // Posters
  map.set("CP-POST-40X60-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-60X40-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-36X48-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-48X36-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-30X40-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-40X30-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-28X40-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-40X28-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-24X36-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-36X24-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-22X28-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-28X22-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-18X24-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-24X18-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-16X20-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-20X16-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-11X17-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-17X11-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-11X14-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("CP-POST-14X11-0000-001", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("poster-prints", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");

  // Single canvas
  map.set(
    "single-canvas-featured-products",
    "73e203fa-0d97-4d92-94b3-6da57f708b73"
  );
  map.set("wall-display", "cd8d180a-75aa-4cbb-9981-88ee8e445328");
  map.set("triptych-prints", "f1633cfa-f462-49f1-9793-b484a5f80f3a");
  map.set("triptych-flow-prints", "bd7167ba-af06-4ea3-82ed-8577f50f13a7");
  map.set("poster-prints", "c2d9a259-5ad7-4ef9-bcee-b83be9a3dbaf");
  map.set("metal-prints", "b42b84b0-3aac-407e-88b9-005813e467b0");
  map.set("pillow-prints", "b67c99ea-884c-4efd-b0df-63e27ca2deb6");
  // Fake asset ids for fabric builder
  map.set("tshirt-womens", "WTSH-001");
  map.set("tshirt-youth", "YTSH-001");
  map.set("tshirt-prints", "TSH-001");
  map.set("magnet-prints", "MAG-001");
  map.set("mousepad-prints", "MOUSEPAD-001");
  map.set("cutting-board-glass-prints", "GLASSCUTTINGBOARD-001");
  map.set("tote-prints", "TOTE-001");
  map.set("tote-prints-large", "TOTE-LG-001");
  map.set("tote-prints-small", "TOTE-SM-001");
  map.set("coaster-prints", "COASTER-001");
  map.set("coaster-square-prints", "SQ-COASTER-001");
  map.set("CP-TOTE-BASIC-0000-001", "TOTE-001");
  map.set("mug-prints", "MUG-001");
  map.set("puzzle-prints", "PUZZLE-001");
  map.set("CP-MUG-BASIC-0000-001", "MUG-001");
  map.set("CP-PUZZLE-8x10-0000-001", "PUZZLE-001");
  map.set("plaque-prints", "PLAQUE-001");
  map.set("CP-PLAQUE-10x8-0000-001", "PLAQUE-001");
  map.set("CP-ART-TOTE-0000-001", "ART-001");
  map.set("acrylic-prints", "ACRYLIC-001");
  map.set("magnet-metal-square", "CP-CML-SQ");
  map.set("magnet-metal-rectangle", "CP-CML-RECT");
  map.set("promo-magnet-prints", "CP-CML-PROMO");
  map.set("magnet-metal-circle", "CP-CML-CIRC");
  map.set("magnet-metal-oval", "CP-CML-OVAL");
  map.set("square-sticker-prints", "CP-STK-SQ");
  map.set("triangle-sticker-prints", "CP-STK-TRI");
  map.set("circle-sticker-prints", "CP-STK-CIRC");
  map.set("oval-sticker-prints", "CP-STK-OVAL");
  map.set("rectangle-sticker-prints", "CP-STK-RECT");
  map.set("ornament-prints", "CP-ORNAMENT-CIRCLE-0000-001");
  map.set("foam-tile-prints", "PFT-001");
  map.set("fleece-blanket-prints", "CP-FLEECE_BLNK-30x40-0000-001");
  map.set("woven-blanket-prints", "CP-WOVEN_BLNK-37x52-0000-001");
  map.set("crewneck-sweatshirt", "CS-001");
  map.set("crewneck-youth-sweatshirt", "YCS-001");
  map.set("hoodie-sweatshirt", "HS-001");
  map.set("hoodie-youth-sweatshirt", "YHS-001");
  map.set("polo-shirt", "PS-001");
  map.set("polo-womens-shirt", "WPS-001");
  map.set("polo-youth-shirt", "YPS-001");
  map.set("acrylic-block-prints", "ABP-001");
  map.set("glass-prints", "GLASS-001");
  map.set("photos-prints", "PHOTO-001");
  map.set("camping-mug-prints", "CAMPING-001");
  map.set("tumbler-prints", "TUMBLER-001");
  map.set("bottle-opener", "BOTTLE-001");
  map.set("water-bottle", "WATERBOTTLE-001");
  map.set("wood-print", "WOOD-001");
  map.set("pulp-coaster-square", "CP-PULP_COASTER_SQUARE");
  map.set("pulp-coaster-round", "CP-PULP_COASTER_ROUND");
  map.set("koozie-16", "KOOZIE-001");
  map.set("koozie-12", "KOOZIE-002");
  map.set("drink-tumbler", "DRINK_TUMBLER-001");
  map.set("bottle-opener-poly", "BOTTLE_OPENER_POLY-001");
  map.set("bottle-opener-brushed", "BOTTLE_OPENER_BRUSHED-001");
  map.set("luggage-tag", "LUGGAGE_TAG-001");
  map.set("dog-tag", "DOG_TAG-001");

  return map;
}

export function mapHandleToAssetId(handle) {
  const map = handleAssetMap();
  return map.get(handle) || map.get("square-1");
}

export function mapSkuToAssetId(sku) {
  const map = skuAssetMap();
  const value = map.get(sku) || map.get(skuToCollection(sku));
  return value;
}

export function skuToCollection(sku) {
  if (sku === undefined || sku === null) {
    return 'single-canvas-featured-products';
  }

  switch (sku.split("-")[1]) {
    case "MTL":
      return "metal-prints";
    case "POST":
      return "poster-prints";
    case "PILL":
      return "pillow-prints";
    case "MAG":
      return "magnet-prints";
    case "TSHIRT":
      return "tshirt-prints";
    case "MOUSEPAD":
      return "mousepad-prints";
    case "GLASS_CUTTING_BOARD":
      return "cutting-board-glass-prints";
    case "TOTE":
      return "tote-prints";
    case "MUG":
      return "mug-prints";
    case "PUZZLE":
      return "puzzle-prints";
    case "ACRYLIC":
      return "acrylic-prints";
    case "ORNAMENT":
      return "ornament-prints";
    case "COASTER":
      return "coaster-prints";
    case "PLAQUE":
      return "plaque-prints";
    case "FLEECE":
      return "fleece-blanket-prints";
    case "WOVEN":
      return "woven-blanket-prints";
    default:
      return "single-canvas-featured-products";
  }
}

export function mapAssetIdToSku(assetId) {
  const map = skuAssetMap();
  for (let [key, value] of map.entries()) {
    if (value == assetId) return key;
  }
}

export function skuToProductType(sku) {
  const abbr = sku.split("-")[1];
  if (abbr === "TRIP") {
    if (sku.split("-")[2] == "CZFL" || sku.split("-")[2] == "CLFL")
      return "triptych-flow";
    return "triptych";
  } else if (abbr === "WALL") {
    return "wall-display";
  } else if (abbr === "COL") {
    return "collage";
  } else if (sku.length === "2") {
    return "collage-size";
  } else if (sku.length === "1") {
    return "depth-size-option";
  } else if (abbr === "POST") {
    return "poster";
  } else if (abbr === "MAG") {
    return "magnet";
  } else if (abbr === "SHIRT") {
    return "tshirt";
  } else if (abbr === "MOUSEPAD") {
    return "mousepad";
  } else if (abbr === "GLASS_CUTTING_BOARD") {
    return "glasscuttingboard";
  } else if (abbr === "TOTE") {
    return "tote";
  } else if (abbr === "MUG") {
    return "mug";
  } else if (abbr === "PUZZLE") {
    return "puzzle";
  } else if (abbr === "ACRYLIC") {
    return "acrylic";
  } else if (abbr === "PLAQUE") {
    return "plaque";
  } else if (abbr === "ORNAMENT") {
    return "ornament";
  } else if (abbr === "sticker") {
    return "sticker";
  } else if (abbr == "FLEECE") {
    return "fleece";
  } else if (abbr == "WOVEN") {
    return "woven";
  } else if (abbr == "PHOTOS") {
    return "photos";
  } else if (abbr == "BOTTLE") {
    return "bottle";
  } else if (abbr == "WOOD") {
    return "wood";
  } else {
    switch (sku) {
      case "single-canvas-featured-products":
        return "single-canvas";
      case "collage-prints":
        return "collage";
      case "wall-display-prints":
        return "wall-display";
      case "triptych-prints":
        return "triptych";
      case "triptych-flow-prints":
        return "triptych-flow";
      case "poster-prints":
        return "poster";
      case "metal-prints":
        return "metal";
      case "pillow-prints":
        return "pillow";
      case "magnet-prints":
        return "magnet";
      case "tshirt-prints":
        return "tshirt";
      case "tshirt-youth":
        return "tshirt-youth";
      case "tshirt-womens":
        return "tshirt-womens";
      case "mousepad-prints":
        return "mousepad";
      case "cutting-board-glass-prints":
        return "glasscuttingboard";
      case "tote-prints":
        return "tote";
      case "tote-prints-large":
        return "large-tote";
      case "mug-prints":
        return "mug";
      case "camping-mug-prints":
        return "camping-mug";
      case "tumbler-prints":
        return "tumbler";
      case "puzzle-prints":
        return "puzzle";
      case "acrylic-prints":
        return "acrylic";
      case "coaster-prints":
        return "coaster";
      case "coaster-square-prints":
        return "coaster-square";
      case "plaque-prints":
        return "plaque";
      case "ornament-prints":
        return "ornament";
      case "foam-tile-prints":
        return "tile";
      case "fleece-blanket-prints":
        return "fleece";
      case "woven-blanket-prints":
        return "woven";
      case "crewneck-sweatshirt":
        return "crewneck";
      case "crewneck-youth-sweatshirt":
        return "crewneck-youth";
      case "hoodie-sweatshirt":
        return "hoodie";
      case "hoodie-youth-sweatshirt":
        return "hoodie-youth";
      case "polo-shirt":
        return "polo";
      case "polo-womens-shirt":
        return "polo-womens";
      case "polo-youth-shirt":
        return "polo-youth";
      case "acrylic-block-prints":
        return "acrylic-block";
      case "glass-prints":
        return "glass";
      case "magnet-metal-circle":
      case "magnet-metal-oval":
      case "magnet-metal-rectangle":
      case "magnet-metal-square":
        return "metal-magnet";
      case "promo-magnet-prints":
        return "promo-magnet"
      case "photos-prints":
        return "photos";
      case "bottle-opener":
        return "bottle";
      case "wood-print":
        return "wood";
      case "pulp-coaster-square":
        return "pulp-square-coaster"
      case "pulp-coaster-round":
        return "pulp-round-coaster"
      case "koozie-16":
        return "koozie-16";
      case "water-bottle":
        return "water-bottle";
      case "koozie-12":
        return "koozie-12";
      case "drink-tumbler":
        return "drink-tumbler";
      case "bottle-opener-poly":
        return "bottle-opener-poly";
      case "bottle-opener-brushed":
        return "bottle-opener-brushed";
      case "tote-prints-small":
        return "small-tote";
      case "luggage-tag":
        return "luggage-tag";
      case "dog-tag":
        return "dog-tag";
    }
  }
}

export function assetIdToProductType(assetId) {
  const sku = mapAssetIdToSku(assetId);
  return skuToProductType(sku);
}
